// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__maytra_603f74', '__maytra_Fallback_603f74'"},"className":"__className_603f74"};